module.exports = __webpack_public_path__ + "img/hyundai-new.94ce123e.png";